import { useState, useEffect } from 'react'
import { projectsAPI } from '../lib/api.js'

export function useProjects() {
  const [projects, setProjects] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        setLoading(true)
        setError(null)
        
        // Get projects from API
        const response = await projectsAPI.getAll()
        setProjects(response.data || [])
      } catch (err) {
        console.error('Error loading projects:', err.message)
        setError('Failed to load projects')
        setProjects([])
      } finally {
        setLoading(false)
      }
    }

    fetchProjects()
  }, [])

  return { projects, loading, error }
}
